import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, RefreshCw, Clock } from 'lucide-react';
import './ErrorPages.css';

const ServiceUnavailable = () => {
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          window.location.reload();
          return 30;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-animation">
          <div className="error-icon-wrapper maintenance">
            <Clock size={80} className="error-icon" />
          </div>
        </div>

        <h1 className="error-code">503</h1>
        <h2 className="error-title">Service Unavailable</h2>
        <p className="error-description">
          We're performing scheduled maintenance. The service will be back shortly.
        </p>

        <div className="countdown">
          <p>Auto-refresh in <strong>{countdown}</strong> seconds</p>
        </div>

        <div className="error-actions">
          <button onClick={handleRefresh} className="error-button primary">
            <RefreshCw size={20} />
            <span>Refresh Now</span>
          </button>
          <Link to="/" className="error-button secondary">
            <Home size={20} />
            <span>Try Home</span>
          </Link>
        </div>

      </div>
    </div>
  );
};

export default ServiceUnavailable;
